
import "./SeriesIntro.css";

function SeriesIntro() {
  return (
    <main id="top" className="series-main">
        <section id="series" className="series-intro">
        <div className="series-intro-grid">

            <div className="series-intro-heading">
            <h2>
                Twenty-six years of history<span style={{ color: "#EF3A5D" }}>.</span> Updated every morning<span style={{ color: "#EF3A5D" }}>.</span>
            </h2>
            </div>

            <p>
              The series runs from January 2000 to June 2026, is updated as new months arrive, and is published on the data page, free to read and reuse with attribution.
            </p>

        </div>
        </section>
    </main>
  );
}

export default SeriesIntro;

